import React, { Component } from 'react';
import { Spin } from 'antd';
import localforage from 'localforage';
import Login from './pages/Login';
import AppLayout from './layouts/AppLayout';

class App extends Component {
  state = {
    appLoading: true,
    user: null,
  };

  componentDidMount() {
    localforage.getItem('user').then((user) => {
      if (user) {
        this.setState({
          user: user.name,
        });
      }
      this.setState({
        appLoading: false,
      });
    });
  }

  onLogin = (user) => {
    this.setState({
      user: user.name,
      appLoading: false,
    });
  };

  render() {
    const { appLoading, user } = this.state;
    if (appLoading) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
          <Spin size="large" />
        </div>
      );
    }
    if (!user) {
      return <Login handleSuccessfulLogin={this.onLogin} />;
    }
    return <AppLayout user={user} />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js